export enum SipClientStatus {
  RECEIVING_CALL = 'RECEIVING_CALL',
  CALLING = 'CALLING',
  ON_CALL = 'ON_CALL',
  NO_ACTIVITY = 'NO_ACTIVITY',
  CALL_WAITING = 'CALL_WAITING',
  MANY_CALL_WAITING = 'MANY_CALL_WAITING',
  CALL_WAITING_WHILE_CALLING = 'CALL_WAITING_WHILE_CALLING',
}
